export function News() {
  return <section>
    <h2>BULLETIN BOARD</h2>
    <ul>
      <li><a href="https://docs.google.com/spreadsheets/d/1qqAzzUdapl9Hwfdm746RTDbZKgov2vL9DMpZoiRTkrM/edit#gid=0" target="_blank" rel="noreferrer">Grocery list spreadsheet</a></li>
      <li><a href="https://docs.google.com/forms/d/e/1FAIpQLScE6jSMcGvHEwSETvbcoeYHUBcFWswI7OtmmCiIWBSjSFCSJQ/viewform" target="_blank" rel="noreferrer">Grocery cost submission form</a></li>
    </ul>
    <h3>Last updated: June 16, 2023 5:10 PM EST</h3>
  </section>;
}